import React from 'react';
import PropTypes from 'prop-types';
export default function ActiveFilters(props) {
  return (
    <div className={props.hasGenre ? 'hearby-activefilters active' : 'hearby-activefilters' }>
    </div>
  );
}

ActiveFilters.propTypes = {
  resetGenre: PropTypes.func,
  genre: PropTypes.object,
  hasGenre: PropTypes.bool,
}

//resetGenre={handleGenreReset} genre={genre} hasGenre={hasGenre}

// import React from 'react';
// import { Button } from 'react-bootstrap';
// const getGenreDivClassname = (genre) => {
//   return "hearby-af hearby-genrefilter-" + genre;
// }
// const getGenreBtnClassname = (genre) => {
//   return "hearby-activegenre-" + genre;
// }
// export default function ActiveFilters(props) {
//   return (
//     <div className={props.hasGenre ? 'hearby-activefilters active' : 'hearby-activefilters' }>
//         {props.hasGenre ?
//       Object.keys(props.genre).map((key,i)=>{
//         return ([
//       props.genre[key] ?
//       <div key={'hearby'+key+1} className={getGenreDivClassname(key)}>
//       <Button className={getGenreBtnClassname(key)} onClick={() => props.resetGenre(key)}>{key}
//         </Button>
//         </div>
//         : null ]) })  : null }
//         {/* {props.hasDate ? 
//         <div className="hearby-af hearby-datefilter">
//       <Button className="hearby-activedate" onClick={props.resetDate}>{props.datetext}
//         </Button>
//         </div>
//         : null}
//         {props.hasDistance ? 
//         <div className="hearby-af hearby-distancefilter">
//       <Button className="hearby-activedistance" onClick={props.resetDist}>{props.distancetext}
//         </Button>
//         </div>
//         : null  } */}
//     </div>
//   );
// }